import { computed, watch, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { RequestContentItem, useRequestContentStore } from '@/store/useRequestContentStore';
import { useViewerItemStore } from '../store/useViewerItemStore';
import { useUser } from './useUser';
import { useAiMetadataStore } from '../store/useAiMetadataStore';
import { useModal } from '@/storybook/modal/useModal';
import ParamsModal from './../components/request_content/ParamsModal.vue';

export const REQUEST_PARAMS_TO_DISPLAY_COUNT = 3;

export const useRequestContentInfoPage = () => {
  const viewerStore = useViewerItemStore();
  const store = useRequestContentStore();
  const { isCurrentItemOwner } = useUser();

  const aiMetadataStore = useAiMetadataStore();
  const { hasChapters } = storeToRefs(aiMetadataStore);
  const { requestContentId, description, requestContentQueryParams } = storeToRefs(viewerStore);
  const { list } = storeToRefs(store);
  const requestContentItem = ref<RequestContentItem | undefined>(undefined);

  const showHorizontalDivider = computed(() => {
    if (isCurrentItemOwner.value) {
      return true;
    }

    if (!description.value?.length || !hasChapters.value) {
      return false;
    }

    return true;
  });

  watch(list, () => (requestContentItem.value = list?.value?.find(item => item.id === requestContentId?.value)));

  const loadData = () => requestContentId?.value && store.loadById(requestContentId?.value);

  const requestParamsToDisplay = computed(() => {
    if (!requestContentQueryParams.value) {
      return [];
    }

    return Object.entries(requestContentQueryParams.value)
      .slice(0, REQUEST_PARAMS_TO_DISPLAY_COUNT)
      .map(([key, value]) => ({ key, value }));
  });

  const showRequestContentParamsModal = () => {
    const params = Object.entries(requestContentQueryParams.value || {}).map(([key, value]) => ({ key, value }));
    const { open } = useModal(ParamsModal, { modalProps: { params } });
    return open();
  };

  const requestContentParamsCount = computed(() => Object.entries(requestContentQueryParams.value || {})?.length);

  return {
    loadData,
    showRequestContentParamsModal,
    list,
    requestContentItem,
    showHorizontalDivider,
    requestContentId,
    requestContentQueryParams,
    requestContentParamsCount,
    requestParamsToDisplay,
  };
};
